import { render, staticRenderFns } from "./DetailsTile.vue?vue&type=template&id=09bd1932&scoped=true"
import script from "./DetailsTile.js?vue&type=script&lang=js&external"
export * from "./DetailsTile.js?vue&type=script&lang=js&external"
import style0 from "./DetailsTile.vue?vue&type=style&index=0&id=09bd1932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bd1932",
  null
  
)

export default component.exports